import { z } from 'zod';

import {
  CompanyId,
  LoanId,
  StepActivationId,
  StepInstanceId,
  TaskId,
  TeamId,
  UserId,
  WorkflowInstanceId,
} from '../BrandedIds';
import { Actor } from '../events/BaseLoanEvent';
import { zodDateOrString } from '../utils';
import { EmptyCollectedData } from './collectedData/TaskCollectedData';
import { TaskStatus } from './TaskStatus';

export const BaseTask = z.object({
  id: TaskId,
  loanId: LoanId.optional(),
  losId: z.string().optional(),
  workflowInstanceId: WorkflowInstanceId.optional(),
  stepInstanceId: StepInstanceId.optional(),
  stepActivationId: StepActivationId.optional(),
  companyId: CompanyId,
  status: TaskStatus,
  dueDate: zodDateOrString.optional(),
  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
  assignees: z.array(UserId).optional(),
  teamAssignees: z.array(TeamId).optional(),
  createdBy: Actor.optional(),
  details: z.string(),
  notes: z.string().optional(), // Additional comments
  primaryBorrowerLastName: z.string().optional(), // includes suffix
  associatedUserName: z.string().optional(), // audit log app user responsible for action
  title: z.string().optional(), // title of dialog box
  completedDate: zodDateOrString.optional(),
  collectedData: EmptyCollectedData,
});
